var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVrification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 600",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M378.04,208.02c0-49.26-40.08-89.34-89.34-89.34c-10.75,0-19.45,8.71-19.45,19.45s8.71,19.45,19.45,19.45 c27.81,0,50.44,22.63,50.44,50.44c0,10.74,8.71,19.45,19.45,19.45C369.33,227.47,378.04,218.76,378.04,208.02L378.04,208.02z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M595.39,489.82L412.93,307.36c21.83-27.25,34.99-61.76,34.99-99.33c0-87.8-71.43-159.23-159.23-159.23 c-87.81,0-159.23,71.43-159.23,159.23c0,87.8,71.43,159.23,159.23,159.23c36.24,0,69.57-12.31,96.36-32.77l182.84,182.84 c3.8,3.8,8.77,5.7,13.75,5.7c4.98,0,9.96-1.9,13.75-5.7C602.99,509.73,602.99,497.42,595.39,489.82L595.39,489.82z M168.35,208.03 c0-66.36,53.98-120.33,120.34-120.33c66.35,0,120.33,53.98,120.33,120.33c0,32.73-13.17,62.41-34.44,84.13 c-0.83,0.59-1.66,1.21-2.4,1.96c-0.46,0.46-0.81,0.98-1.21,1.48c-21.54,20.25-50.45,32.77-82.27,32.77 C222.34,328.36,168.35,274.39,168.35,208.03L168.35,208.03z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrification);
export default __webpack_public_path__ + "static/media/vérification.ff2c470197b3d4ac7c21fc5faa5d9d98.svg";
export { ForwardRef as ReactComponent };